<template>
  <div id="choices">
    <div v-for="(i, index) in propositions.length-1" :key="index">
      <div
          class="proposition flexwrap centercenter paddingRound mediumRoundAngles mediumShadow"
          :class="{plainGoldTheme:level>=3, plainSilverTheme:level==2, plainCopperTheme:level==1, plainStandardTheme:level==0, }"
          :style="[answerNum!=-1?{color:textcolor(i)}:{}]"
          v-if="i>0" @click="saveAnswer(i)">
        <!--<div class="key" v-if="screenWidth>767">{{i}}</div>-->
        <span v-if="answerNum!=i">{{ propositions[i].lemma.separateTrads[0] }}</span>
        <span v-if="answerNum==i && !goodAnswer" class="skull"><i class="far fa-times-circle"></i></span>
        <transition name="fadethumb" mode="out-in">
                        <span v-if="answerNum==i && thumb " class="thumbs_up" :key="thumb"><i
                            class="fas fa-star"></i></span>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "quizAnswer",

  props: {
    answer: String,
    propositions: Array
  },

  computed: {
    ...mapGetters('global', [
      'isMobile',
    ]),
    level: function () {
      if (this.propositions[0].lemma.user_lemma.length > 0) {
        return this.propositions[0].lemma.user_lemma[0].knowledge_level
      }
      return 0
    },
  },

  methods: {
    textcolor: function (num) {
      // On colore les mots lorsqu'une réponse a été proposée
      if (this.answerNum !== -1) {
        // On colore la réponse que l'utilisateur a choisi
        if (this.answerNum == num) {
          // Si la réponse proposée est correcte
          if (this.propositions[num].lemma.english === this.propositions[0].lemma.english) {
            return '#f00'
          }

        } else {
          // Si une autre proposition était la bonne on la colore en vert
          if (this.propositions[num].lemma.english === this.propositions[0].lemma.english) {
            return 'var(--correctAnswerColor)';
          }
        }
      }
      // Avant qu'une réponse aie été choisie
      else {
        return '#ccc';
      }
    },

    saveAnswer: function (num) {
      // On enregistre la réponse uniquement si aucune n'a déjà été donné
      if (this.answerNum === -1) {
        if (!this.goodAnswer) {
          this.answerNum = num;
          if (this.propositions[num].lemma.english === this.propositions[0].lemma.english) {
            this.goodAnswer = true;
            window.setTimeout(() => {this.sendAnswer(true)}, 400);
            // Pendant les 400 ms qui séparent la bonne réponse au passage à la slide suivante, on effectue la transition de l'étoile
            this.starFullness++;
            this.thumb = true;
            window.setTimeout(() => (this.thumb = false), 10);
          } else {
            this.goodAnswer = false;
            //this.answer = -1
            //window.setTimeout(() => {this.propositions = this.initWord(this.wordNum, this.currentEpisodeData.vocab)}, 800)
            //window.setTimeout(this.validate, 1200);
            window.setTimeout(() =>  {this.sendAnswer(false)}, 800);
          }
        }
      }
    },

    sendAnswer(isCorrect) {
      this.$emit('answer', isCorrect)
    }
  },

  data() {
    return {
      answerNum: -1,
      goodAnswer: false,
      thumb: false,
    }
  }
}
</script>

<style scoped>
  #choices {
    display: grid;
    grid-template-columns: auto auto;
    grid-template-rows: auto auto;
    grid-gap: 1vw;
    padding-left: 1vw;
    padding-right: 1vw;
    width: calc(100% - 2vw);
    justify-content: center;
  }

  .proposition {
    position: relative;
    font-size: 150%;
    font-weight: bold;
    width: 14vw;
    height: 2.5em;
    text-align: center;
    cursor: pointer;
  }

  .thumbs_up {
    position: absolute;
    height: 100%;
    align-content: center;
    font-size: 150%;
    color: #59daff;
  }

  .skull {
    font-size: 150%;
    color: #FF5E3D;
  }

  .fadethumb-leave-active {
    transition: all .4s;
    -webkit-transition: all .4s;
    -ms-transition: all .4s;
  }

  .fadethumb-leave-to /* .fade-leave-active below version 2.1.8 */
  {
    opacity: 0;
    transform: translateY(-2vw);
  }

  @media screen and (max-device-width: 767px) {
    #choices {
      grid-template-rows: auto auto auto auto;
      grid-template-columns: auto;
      grid-gap: 3vw;
      padding-left: 3vw;
      padding-right: 3vw;
      width: calc(100% - 6vw);
    }
    .proposition {
      width: 56vw;
      height: 2.5em;
    }
    .fadethumb-leave-to /* .fade-leave-active below version 2.1.8 */
    {
      transform: translateY(-8vw);
    }
  }
</style>